import { UserRole } from "../../app/userSlice";
import { SiteConfig } from "../config/configApiSlice";

export const externalIdLabel = (
	userRole: UserRole | string,
	config: SiteConfig | null,
	lowercaseStart?: boolean
) => {
	return userRole === UserRole.Writer && config?.isUtahComposeSite
		? config.writerExtIdLabel
		: userRole === UserRole.Proctor && config?.isUtahComposeSite
			? config.proctorExtIdLabel
			: lowercaseStart
				? "external ID"
				: "External ID";
};
